export default __webpack_public_path__ + "static/media/login-banner.0fee5b97.jpg";